(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (Shopify.designMode) {
    $(document).on('shopify:section:load shopify:section:unload', function(){
      const hero = new Swiper('.hero', {
        speed: 800,
        loop: true,
        effect: 'slide',
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        roundLengths: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        lazy: {
          threshold: 50,
          observer: true,
          loadPrevNext: true,
          loadOnTransitionStart: true
        },
        wrapperClass: 'hero_slide',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          540: {
            slidesPerView: 'auto',
            spaceBetween: 30
          }
        }
      });
    })
  }

  } catch(e) { console.error(e); }
})();
})();
